export default __webpack_public_path__ + "4a67e207ded11432a116ad3d40bdc381.otf";